export default "__VITE_ASSET__CNkQkUo5__"